module.exports = __webpack_public_path__ + "media/favicon/mstile-310x150-4dc965da.png";